export default __webpack_public_path__ + "static/leader_emea_sm_spring.png";